import React, {useContext, useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {
    Button,
    Card,
    CardContent,
    Snackbar
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import {useFormik} from "formik";
import axios from "axios";
import AuthContext from "../../context/AuthContext";
import Alert from "@material-ui/lab/Alert";


const useStyle = makeStyles(() => ({
    configurationContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    configurationBody: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "auto",
        columnGap: "48px"
    },
    formTitle: {
        fontFamily: "Poppins",
        fontWeight: '500',
        fontSize: "20px",
        color: "#bb0d66",
        textAlign: "center"
    },
    innerCardStyle: {
        boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
        width: "400px",
        height: "auto",
        margin: "16px 0",
        padding: "8px"
    },
    innerCardTitle: {
        color: "#3D4977",
        textAlign: "left",
        fontFamily: "EncodeSansBold",
        fontSize: "16px",
    },
    innerCardField: {
        '& label.Mui-focused': {
            color: "#BB0D66",
        },
    },
    buttons: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "100%",
        padding: "8px 0px"
    },
    buttonConfirm: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "14px",
        backgroundColor: "#BB0D66",
        padding: "4px 16px",
        margin: "8px 0 -8px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
}))

function ConfigurationOptions() {
    const classes = useStyle();
    const {authToken} = useContext(AuthContext);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertSeverity, setAlertSeverity] = useState(null);

    const handleOpenAlert = (message, severity) => {
        setOpenAlert(true);
        console.log("MESSAGE", typeof message)
        setAlertMessage(message);
        setAlertSeverity(severity)
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
        setAlertMessage(null);
        setAlertSeverity(null)
    };

    const formik = useFormik({
        initialValues: {
            password: '',
        },
        // validationSchema: validationSchema,
        onSubmit: (values, actions) => {
            const url = process.env.REACT_APP_BACK_SERVER + '/update-password'
            actions.setSubmitting(true);

            axios.post(url, values, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`,
                }
            }).then(res => {
                handleOpenAlert(res['data'], "success")
            }).catch(err => {
                handleOpenAlert("Ha ocurrido un error: " + err, "warning")
            }).finally(() => {
                actions.setSubmitting(false);
                actions.setFieldValue("password", "")
            });
        },
    });

    return (
        <>
            <div className={classes.configurationContainer}>
                <h3 className={classes.formTitle}>Opciones de configuración</h3>

                <div className={classes.configurationBody}>
                    <Card className={classes.innerCardStyle}>
                        <CardContent style={{height: "100%", padding: "8px"}}>
                            <p className={classes.innerCardTitle}>Modificar contraseña de registro</p>

                            <form onSubmit={formik.handleSubmit}>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    className={classes.innerCardField}
                                    id="password"
                                    label="Nueva contraseña"
                                    fullWidth
                                    value={formik.values.password}
                                    error={formik.touched.password && Boolean(formik.errors.password)}
                                    helperText={formik.touched.password && formik.errors.password}
                                    onChange={formik.handleChange}
                                />


                                <div className={classes.buttons}>
                                    <Button type="submit"
                                            disabled={formik.isSubmitting}
                                            className={classes.buttonConfirm}>
                                        Aceptar
                                    </Button>
                                </div>
                            </form>

                        </CardContent>
                    </Card>


                </div>
            </div>
            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity={`${alertSeverity}`} elevation={6} variant="filled">
                    {alertMessage}
                </Alert>
            </Snackbar>
        </>
    );
}

export default ConfigurationOptions;